import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPngMakerConfig } from '@/data/landingConfig/landingPngMakerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PngMaker } from './schemaObject';

interface Props {}
const PngMaker: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PngMaker} />
			<LandingTemplate
				data={landingPngMakerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default PngMaker;
